import { memo, useCallback, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import { AttachArticle } from "@coworker/apprestructured/src/task-management/components/AttachArticle/AttachArticle";
import { ItemNoAndType } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";

function AttachArticleDemo() {
  const [itemNoAndType, setItemNoAndType] = useState<ItemNoAndType>({
    no: "",
    type: "",
  });

  const [disabled, setDisabled] = useState(false);

  const { data: item } = useItemInfo(itemNoAndType.no);

  const handleItemChange = useCallback((newItemNoAndType: ItemNoAndType) => {
    setItemNoAndType({ no: newItemNoAndType.no, type: newItemNoAndType.type });
  }, []);

  return (
    <Demo>
      <Name>AttachArticle</Name>
      <Highlight>
        <FixaListView id="attacharticledemo" size="small">
          <AttachArticle
            item={item ?? null}
            setItemNoAndType={handleItemChange}
            disabled={disabled}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="attacharticledemo-disabled"
          id="attacharticledemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(AttachArticleDemo);
